/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _join = _interopRequireDefault(require("../../../common/join"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DEFAULT_CLASS_NAME = 'inovua-react-toolkit-load-mask__loader';
var InovuaSvgLoader = function (_React$Component) {
  (0, _inherits2.default)(InovuaSvgLoader, _React$Component);
  var _super = _createSuper(InovuaSvgLoader);
  function InovuaSvgLoader() {
    (0, _classCallCheck2.default)(this, InovuaSvgLoader);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(InovuaSvgLoader, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var style = _objectSpread(_objectSpread({}, props.style), {}, {
        width: props.size,
        height: props.size
      });
      if (props.animationDuration) {
        style.animationDuration = props.animationDuration;
      }
      var className = (0, _join.default)(props.className, DEFAULT_CLASS_NAME, "".concat(DEFAULT_CLASS_NAME, "--svg"), props.theme && "".concat(DEFAULT_CLASS_NAME, "--theme-").concat(props.theme));
      return _react.default.createElement("div", {
        style: style,
        className: className
      }, _react.default.createElement("svg", {
        className: "".concat(DEFAULT_CLASS_NAME, "-spinner"),
        width: props.size,
        height: props.size,
        viewBox: "0 0 32 32"
      }, _react.default.createElement("path", {
        fillRule: "evenodd",
        d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-4c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12z"
      })));
    }
  }]);
  return InovuaSvgLoader;
}(_react.default.Component);
exports.default = InovuaSvgLoader;
InovuaSvgLoader.propTypes = {
  size: _propTypes.default.number,
  theme: _propTypes.default.string,
  animationDuration: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
InovuaSvgLoader.defaultProps = {
  size: 40
};


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/LoadMask/src/SvgLoader.js
// module id = 693
// module chunks = 0